<template>
  <b-card class="bg-white rounded-xl px-2">
    <div class="flex justify-between items-center">
      <div>
        <h2 class="text-2xl font-semibold">List of Service Categories</h2>

        <small class="text-muted">Manage all your service categories. </small>
      </div>

      <base-button
        outline
        class="px-6 py-1 mx-1"
        type="primary"
        @click="handleAdd"
      >
        <span class="btn-inner--text flex justify-between items-center"
          ><feather-icon icon="PlusIcon" class="cust-HW"></feather-icon> Create
          Service
        </span>
      </base-button>
    </div>
    <BlogExclusiveTable />
  </b-card>
</template>

<script>
import BlogExclusiveTable from "./components/BlogExclusiveTable.vue";

export default {
  components: {
    BlogExclusiveTable,
  },
  methods: {
    handleAdd() {
      this.$router.push({ name: "addexclusiveblogcontent" });
    },
  },
  async mounted() {
    await this.$store.dispatch("subscribe/GetAllMembership");
  },
};
</script>
